<template>

<div>
  <LDBsTable
    url="financial/vehicles"
    defaultSort="id"
    defaultOrder="desc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="serie">{{ $t('serie') }}</label>
      <input
        type="text"
        id="serie"
        name="serie"
        class="form-control"
        :placeholder="$t('ph_serie')"
        v-model="query.serie"
        @input="upper('serie')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        class="form-control"
        id="board"
        name='board'
        :placeholder="$t('ph_board')"
        v-model="query.board"
        @input="upper('board')"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="isActive">{{ $t('active') }}</label>
      <Combobox
        class="bg-white"
        name='isActive'
        :placeholder="$t('select_a_item')"
        label="label"
        :initial-value="query.isActive"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.isActive"
        :reduce="active => active.value"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="contract">{{ $t('contract') }}</label>
      <Combobox
        class="bg-white"
        name='contract'
        :placeholder="$t('select_a_item')"
        :options="contracts"
        :initial-value="query.contract"
        label="contracts"
        v-model="query.contract"
        :reduce="contract => contract.id_contrato"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="client">{{ $t('client') }}</label>
      <Combobox
        class="bg-white"
        name='client'
        :placeholder="$t('select_a_item')"
        :options="clients"
        :initial-value="query.client"
        label="nome_cliente"
        v-model="query.client"
        :reduce="client => client.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="description">{{ $t('description') }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="query.description"
        @input="upper('description')"
      >
    </div>
  </LDBsTable>

  <!-- MODAL ACTIVE/INACTIVE VEHICLE -->
  <div
    class="modal fade"
    id="modalActiveInactiveVehicle"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalActiveInactiveVehicleLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalActiveInactiveVehicleLabel">
            {{ !dataToUpdate.isActive ? 'Desativar' : 'Ativar' }} veículo {{ dataToUpdate.id }}
          </h5>

          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ul>
            <li>
              SERIAL: <strong>{{ dataToUpdate.EQUIPMENT_SERIAL }}</strong>
            </li>
            <li>
              CLIENTE/CONTRATO: <strong>{{ dataToUpdate.contract }} [{{ dataToUpdate.client }}]</strong>
            </li>
            <li>
              VEÍCULO: <strong>{{ getVehicleInfo() }}</strong>
            </li>
            <li>
              DESCRIÇÃO: <strong>{{ dataToUpdate.description }}</strong>
            </li>
            <li>
              MODELO (MÓDULO): <strong>{{ dataToUpdate.chassis }}</strong>
            </li>
          </ul>

          <div
            class="form-group col-lg-6"
            v-if="!dataToUpdate.isActive"
            :class="{ 'has-error': errors.has('disactivateDate') }"
          >
            <label for="disactivateDate">{{ $t("disactivateDate") }}</label>
            <input
              type="datetime-local"
              id="disactivateDate"
              name="disactivateDate"
              class="form-control"
              :placeholder="$t('ph_disactivateDate')"
              v-model="dataToUpdate.disactivateDate"
              step="1"
            />

            <small v-show="errors.has('disactivateDate')" class="form-text text-muted">
              {{ errors.first("disactivateDate") }}
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            :disabled="isLoading"
          >
            {{ $t("close") }}
          </button>

          <LoaderButton
            class="mt-3"
            @click="updateVehicleStatus"
            :loading="isLoading"
          >
            {{ $t(dataToUpdate.isActive ? "to_active" : "to_desactive") }}
          </LoaderButton>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import moment from 'moment'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'
import { apiBaseUrl } from '@/lib/config'
import axios from 'axios'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'FinancialVehicleList',

  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('serial'),
          field: 'EQUIPMENT_SERIAL',
          sortable: true
        },
        {
          title: this.$t('description'),
          field: 'DESCRI',
          sortable: false
        },
        {
          title: this.$t('board'),
          field: 'PLATE',
          sortable: false
        },
        {
          title: this.$t('code'),
          field: 'COD',
          sortable: false,
          visible: false
        },
        {
          title: this.$t('model'),
          field: 'MODEL',
          sortable: false,
          visible: false
        },
        {
          title: this.$t('brand'),
          field: 'COMPANY',
          sortable: false,
          visible: false
        },
        {
          title: this.$t('module_model'),
          field: 'CHASSIS',
          sortable: false
        },
        {
          title: this.$t('installation_date'),
          field: 'data_instalacao_veiculo_maxfrota',
          formatter: function (value) {
            if (!value) {
              return '-'
            }

            try {
              const [year, month, day] = value.split('T')[0].split('-')

              return `${day}/${month}/${year}`
            } catch (error) {
              return value
            }
          },
          sortable: false
        },
        {
          title: this.$t('disactivateDate'),
          field: 'DISACTIVATE_DATE',
          formatter: function (value) {
            if (!value) {
              return '-'
            }

            try {
              const [year, month, day] = value.split('T')[0].split('-')
              const time = value.split('T')[1].split('.')[0]

              return `${day}/${month}/${year} ${time}`
            } catch (error) {
              return value
            }
          },
          sortable: false,
          visible: false
        },
        {
          title: this.$t('contract'),
          field: 'contractName',
          sortable: false
        },
        {
          title: this.$t('client'),
          field: 'clientName',
          sortable: false
        },
        {
          title: this.$t('active'),
          field: 'DISACTIVATE',
          formatter: function(value) {
            return value ? 'NÃO' : 'SIM'
          },
          align: 'center',
          sortable: false
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            let buttons = `
              <a
                href="#/main/financial/vehicle/${value}"
                class="
                  edit
                  btn
                  btn-action
                  btn-primary
                  btn-circle
                  light-bottom-shadow
                  text-white
                "
              >
                <i class="fas fa-pen" />
              </a>
            `

            const isActive = row.DISACTIVATE

            buttons += `
              <button
                title="${isActive ? 'Ativar' : 'Desativar'} veículo"
                data-target="#modalActiveInactiveVehicle"
                data-id='${value}'
                data-serie='${row.EQUIPMENT_SERIAL}'
                data-contract='${row.contractName}'
                data-client='${row.clientName}'
                data-code='${row.COD}'
                data-color='${row.COLOR}'
                data-company='${row.COMPANY}'
                data-description='${row.DESCRI}'
                data-year='${row.YEAR}'
                data-disactivate='${row.DISACTIVATE}'
                data-model='${row.MODEL}'
                data-plate='${row.PLATE}'
                data-chassis='${row.CHASSIS}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-${!isActive ? 'danger' : 'success-green'} btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-${!isActive ? 'times' : 'check'}" />
              </button>
            `

            return buttons
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'financial_vehicles' }
      },
      queryToUse: {},
      query: {
        serie: '',
        board: '',
        isActive: undefined,
        contract: '',
        client: '',
        description: ''
      },
      dataToUpdate: {}
    }
  },

  computed: {
    ...mapState({
      contracts: state => state.contracts.all,
      clients: state => state.financial.clients,
      lastquery: state => state.filtershistory.query,
      isLoading: state => state.financial.isLoading
    })
  },

  methods: {
    clear() {
      this.query.serie = ''
      this.query.board = ''
      this.query.isActive = undefined
      this.query.contract = ''
      this.query.client = ''
      this.query.description = ''
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    },

    async exportCSV() {
      const { dispatch } = this.$store

      try {
        dispatch('overlay/show', true)

        const data = await axios.get(`${apiBaseUrl()}export-financial-vehicles-csv`, { responseType: 'blob' })

        const url  = window.URL.createObjectURL(new Blob([data.data], { type: 'text/csv; charset=latin1' }))
        const link = document.createElement('a')
        link.href  = url
        link.setAttribute('download', 'veiculos_financeiro.csv')
        document.body.appendChild(link)
        link.click()

      } catch (error) {
        dispatch('notify/error', { message: error }, { root: true })
      } finally {
        dispatch('overlay/show', false)
      }
    },

    getVehicleInfo() {
      const { plate, company, year, model } = this.dataToUpdate

      const info = [plate, company, model, year]

      return info.filter(Boolean).join(' / ') || '-'
    },

    async updateVehicleStatus() {
      const { dispatch } = this.$store
      const { isActive, id, disactivateDate } = this.dataToUpdate

      const toActive = isActive

      if (toActive) {
        await dispatch('financial/activeVehicle', id)
      } else {
        if (!disactivateDate) {
          this.errors.add({
            field: 'disactivateDate',
            msg: this.$t('ph_disactivateDate'),
          })

          return
        }

        await dispatch(
          'financial/inactiveVehicle',
          {
            id,
            data: { disactivateDate }
          })
      }

      $("#modalActiveInactiveVehicle").modal("hide");
      $("#search").trigger("click");
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['financialvehicle'] ? this.lastquery['financialvehicle'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    await Promise.all([
      dispatch('contracts/fetchAllContracts', { isActive: true }),
      dispatch("financial/fetchClients")
    ])

    if (this.lastquery['financialvehicle']) {
      for (const [key, value] of Object.entries(this.lastquery['financialvehicle'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    const global = this

    $("#modalActiveInactiveVehicle").on("show.bs.modal", function (event) {
      global.errors.clear()

      const button = $(event.relatedTarget);

      global.dataToUpdate = {
        id: button.data("id"),
        EQUIPMENT_SERIAL: button.data("serie"),
        contract: button.data("contract"),
        client: button.data("client"),
        cod: button.data("code"),
        color:  button.data("color"),
        company: button.data("company"),
        description: button.data("description"),
        year: button.data("year"),
        isActive: button.data("disactivate"),
        model: button.data("model"),
        plate: button.data("plate"),
        chassis: button.data("chassis") || '-',
        disactivateDate: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    });

    $("#modalActiveInactiveVehicle").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {}
    });

    $('#toolbar')
      .find('div:first')
      .append(`
        <button
          id="export"
          class="btn btn-primary text-white right"
          aria-expanded="true"
        >
          ${this.$t('export_csv')}
        </button>
      `)

    $('#export').on('click', function() {
      global.exportCSV()
    })
  },

  destroyed () {
    this.$store.dispatch(
      'filtershistory/setQuery',
      {
        key: 'financialvehicle',
        query: this.query
      }
    )
  },
}

</script>
